import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3c49014"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "messages" }, null, -1))
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text-blue-700 font-bold dark:text-blue-300" }
const _hoisted_4 = { class: "mb-0 font-bold" }
const _hoisted_5 = { class: "actions flex justify-end gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "table list"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Tidspunkt"),
    /*#__PURE__*/_createElementVNode("th", null, "Endret av"),
    /*#__PURE__*/_createElementVNode("th", null, "Felter endret")
  ])
], -1))
const _hoisted_8 = { class: "align-top" }
const _hoisted_9 = { class: "align-top" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "field-text"
}
const _hoisted_12 = {
  key: 1,
  class: "list empty-activities"
}

import Card from "@/Components/General/Card.vue";
import Button from "@/Components/Buttons/Button.vue";
import FieldDiffModal from "@/Components/General/FieldDiffModal.vue";
import dayjs from "dayjs";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LogEntry',
  props: {
    type: {},
    title: {},
    activities: {},
    labels: {}
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;





// Modal state
const showDiffModal = ref(false);
const selectedFieldLabel = ref('');
const selectedFieldName = ref('');
const selectedOldValue = ref('');
const selectedNewValue = ref('');

const close = () => {
    emit("close");
}

const getChangedFields = (activity: any) => {
    const oldProps = activity.properties?.old || {};
    const newProps = activity.properties?.attributes || {};

    const changedFields: Array<{name: string, label: string, hasChanges: boolean}> = [];

    if (Object.keys(oldProps).length === 0) {
        changedFields.push({name: 'created', label: 'Opprettet', hasChanges: false});
        return changedFields;
    }

    for (const key in newProps) {
        const oldValue = oldProps[key];
        const newValue = newProps[key];

        // Helper function to normalize values for comparison
        const normalizeValue = (value: any): string => {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            
            // Handle arrays (like category_ids, participant_ids, etc.)
            if (Array.isArray(value)) {
                return value.length === 0 ? '' : JSON.stringify(value.sort());
            }
            
            // Handle objects
            if (typeof value === 'object') {
                return JSON.stringify(value);
            }
            
            return String(value).trim();
        };

        const normalizedOld = normalizeValue(oldValue);
        const normalizedNew = normalizeValue(newValue);

        // Only consider it changed if the normalized values are actually different
        if (normalizedOld !== normalizedNew) {
            const label = props.labels[key] || key;
            changedFields.push({
                name: key,
                label: label,
                hasChanges: true
            });
        }
    }

    return changedFields;
}

const showDiff = (activity: any, fieldName: string, fieldLabel: string) => {
    const oldProps = activity.properties?.old || {};
    const newProps = activity.properties?.attributes || {};
    
    // Helper function to format values for display
    const formatValueForDisplay = (value: any): string => {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        
        // Handle arrays
        if (Array.isArray(value)) {
            return value.length === 0 ? '(tom)' : JSON.stringify(value, null, 2);
        }
        
        // Handle objects
        if (typeof value === 'object') {
            return JSON.stringify(value, null, 2);
        }
        
        return String(value);
    };
    
    selectedFieldLabel.value = fieldLabel;
    selectedFieldName.value = fieldName;
    selectedOldValue.value = formatValueForDisplay(oldProps[fieldName]);
    selectedNewValue.value = formatValueForDisplay(newProps[fieldName]);
    showDiffModal.value = true;
}

const closeDiffModal = () => {
    showDiffModal.value = false;
}

const formatDate = (date: string) => {
    return dayjs(date).format("DD.MM.YYYY HH:mm");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, { class: "p-8 rfp-log" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.type), 1),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _renderSlot(_ctx.$slots, "featured_text")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Button, {
          color: "primary",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Tilbake til rapport ")
          ]),
          _: 1
        })
      ]),
      (_ctx.activities.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (activity) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: activity.id
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(formatDate(activity.created_at)), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(activity.causer.firstname) + " " + _toDisplayString(activity.causer.lastname), 1),
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getChangedFields(activity), (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field.name,
                        class: "field-item"
                      }, [
                        (field.hasChanges)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (showDiff(activity, field.name, field.label)),
                              class: "field-button"
                            }, _toDisplayString(field.label), 9, _hoisted_10))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(field.label), 1))
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, " Ingen endringslogg ")),
      (showDiffModal.value)
        ? (_openBlock(), _createBlock(FieldDiffModal, {
            key: 2,
            "field-label": selectedFieldLabel.value,
            "field-name": selectedFieldName.value,
            "old-value": selectedOldValue.value,
            "new-value": selectedNewValue.value,
            onClose: closeDiffModal
          }, null, 8, ["field-label", "field-name", "old-value", "new-value"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})